// React
import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";

// Bootstrap Components
import { Nav, Navbar, NavItem, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Eventify Components
import AccountModal from "./components/AccountModal";
import MainSideNav from "./components/MainSideNav";
import TopBar from "./components/TopBar";

// Router
import Routes from "./Routes";

// AWS
import { Auth } from "aws-amplify";

// ant design
import "antd/dist/antd.css";

// Local Storage
import ls from 'local-storage';

function App(props) {
  const [authData, userHasAuthData] = useState(null);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [currentDB, setCurrentDB] = useState({});

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    //
    if (authData == null) {
      const localStorageAuthData = ls.get('authData');
      if (localStorageAuthData == null) {
        // dont do anything, they are unauth
      } else {
        const providerType = localStorageAuthData.providerType;
        if (providerType === "amazon") {
          userHasAuthData(localStorageAuthData);
        } else if (providerType === "google") {
          userHasAuthData(localStorageAuthData);
        }
      }
    } else {
      ls.set('authData', authData);
    }

    // if (authData == null) {
    //   // this is less of a duplica
    //   try {
    //     Auth.currentSession()
    //     .then(data => {
    //       let idToken = data.getIdToken();
    //       // console.dir(idToken);
    //       const email = idToken.payload.email;
    //       userHasAuthData({"providerType": "amazon", "email": email});
    //       // alert("hello " + email)
    //     })
    //     .catch(err =>
    //   } catch (e) {
    //     if (e !== "No current user") {
    //       alert(e);
    //     }
    //   }
    // } else {
    //   if (authData.providerType === "amazon") {
    //     Auth.currentSession()
    //     .then(data => {
    //       let idToken = data.getIdToken();
    //       // console.dir(idToken);
    //       userHasAuthData({"providerType": "amazon", "email": idToken.payload.email});
    //       // alert("hello " + email)
    //     })
    //     .catch(err =>
    //   } else if (authData.providerType === "google") {
    //       userHasAuthData(authData);
    //   }
    // }

    setIsAuthenticating(false);
  }

  const localStorageAuthData = ls.get("authData");

  let email = "";
  if (localStorageAuthData == null) {
    // dont do anything, they are unauth
  } else {
    const providerType = localStorageAuthData.providerType;
    if (providerType === "amazon") {
      email = localStorageAuthData.email;
    } else if (providerType === "google") {
      email = localStorageAuthData.email;
    }
  }

  let organizationid = ls.get("organizationid");

  let appProps = { authData, userHasAuthData, email, organizationid };

  const isSimplePage = props.location.pathname.match(/^\/login|\/signup/)

  return (
    !isAuthenticating && (
      <div className={isSimplePage ? "app is-simple" : "app"}>
        <TopBar authData={authData} userHasAuthData={userHasAuthData} />
        {!isSimplePage &&
          <MainSideNav
            showAccountModal={() => {setIsAccountModalOpen(true);}}
          />
        }
        <div className="page">
          <Routes appProps={appProps} />
        </div>

        <AccountModal
          visible={isAccountModalOpen}
          onCancel={() => {setIsAccountModalOpen(false);}}
        />
      </div>
    )
  );
}

export default withRouter(App);
